import React from 'react';
import styled from 'styled-components';

const ConverterContainer = styled.div`
  width: 100%;
  height: 100vh;
  background: linear-gradient(135deg, #6b46c1 0%, #4338ca 25%, #1e1b4b 75%, #000000 100%);
  padding: 0;
  margin: 0;
  overflow: hidden;
`;

const ConverterFrame = styled.iframe`
  width: 100%;
  height: calc(100vh - 80px);
  border: none;
  background: white;
`;

const AudioConverter: React.FC = () => {
  return (
    <ConverterContainer>
      <ConverterFrame
        src="/audio-converter/index.html"
        title="Audio to Sheet Music Converter"
      />
    </ConverterContainer>
  );
};

export default AudioConverter;
